import moment from 'moment'

const getSegmentAIncentive = (workingDuration, completedOrders, score) => {
  let incentive = 0

  if (workingDuration >= 6 && completedOrders >= 8 && score >= 50) {
    if (score >= 75) {
      incentive = (score / 100) * 2.5
    } else {
      incentive = (score / 100) * 1.5
    }
  }

  return incentive
}

const getSegmentBIncentive = (workingDuration, completedOrders, score) => {
  let incentive = 0
  if (workingDuration >= 5 && completedOrders >= 7 && score >= 50) {
    if (score >= 75) {
      incentive = (score / 100) * 2.25
    } else {
      incentive = (score / 100) * 1.25
    }
  }

  return incentive
}

const getSegmentCIncentive = (workingDuration, completedOrders, score, zeroScoreCount) => {
  if (zeroScoreCount >= 3) return 0

  let incentive = 0

  if (workingDuration >= 5 && completedOrders >= 6 && score >= 55) {
    if (score >= 75) {
      incentive = zeroScoreCount >= 3 ? 0 : (score / 100) * 1.5
    } else {
      incentive = zeroScoreCount >= 3 ? 0 : (score / 100) * 0.75
    }
  }

  return incentive
}

const getSegmentZIncentive = (workingDuration, completedOrders, score, zeroScoreCount) => {
  if (zeroScoreCount >= 3) return 0

  let incentive = 0

  if (workingDuration >= 6 && completedOrders >= 6 && score >= 50) {
    if (score >= 80) {
      incentive = zeroScoreCount >= 3 ? 0 : (score / 100) * 1.75
    } else {
      incentive = zeroScoreCount >= 3 ? 0 : (score / 100)
    }
  }

  return incentive
}

const calculateIncentive = (segment, driverPerformances) => {
  const dates = Object.keys(driverPerformances)
  const performances = Object.values(driverPerformances)
  const zeroScoring = performances.filter(performance => performance.scoring === 0)
  const zeroScoringCount = performances.length > 0 ? zeroScoring.length : 3
  const incentives = []

  for (let index = 0; index < dates.length; index += 1) {
    const date = dates[index];
    const performance = driverPerformances[date]

    const { duration: workingDurationInMins, deliveredOrderCount, scoring } = performance || {}
    const workingDuration = parseInt(moment.duration(workingDurationInMins, "minutes").asHours(), 10)

    const incentive = {
      A: getSegmentAIncentive(workingDuration, deliveredOrderCount, scoring),
      B: getSegmentBIncentive(workingDuration, deliveredOrderCount, scoring),
      C: getSegmentCIncentive(workingDuration, deliveredOrderCount, scoring, zeroScoringCount),
      Z: getSegmentZIncentive(workingDuration, deliveredOrderCount, scoring, zeroScoringCount),
    }[segment]

    incentives.push({ date, incentive })
  }

  return incentives
}

export default {
  calculateIncentive
}



// WEBPACK FOOTER //
// ./src/prototypes/driverIncentive.js